module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_okinawa_churaumi_aquarium-9b72215af5fad4cf23644737869eed39.jpg";